/* Kaddanse Kissa, 24.10 : le bandeau cookies Consentmo aux couleurs du brouillon.
   L'application dessine son bandeau dans un shadow DOM ouvert (<csm-cookie-consent>) :
   la feuille du thème n'y entre pas, on y glisse donc une feuille dédiée.
   Seules les couleurs, les coins et la casse changent ; « Refuser » et « Accepter »
   gardent le même poids visuel (exigence CNIL). Les réglages de l'application ne
   sont pas touchés : le thème en ligne garde son bandeau. */
(function () {
  var CSS = [
    '.csm-cookie-box-window{background:#F3ECE1!important;color:#1F1915!important;border:1px solid #DDD2C1!important;border-radius:6px!important;box-shadow:0 14px 36px -12px rgba(20,17,14,.45)!important}',
    '.csm-cookie-box-window p,.csm-cookie-box-window span,#isense-cc-cookie-bar-text,#cookieconsent-desc{color:#1F1915!important}',
    '.cc-link,.isense-cc-link{color:#8E561C!important;text-decoration-color:rgba(142,86,28,.45)!important}',
    '.cc-btn.cc-allow,.cc-btn.cc-deny,.cc-btn.cc-save,.cc-btn.cc-accept-all,.cc-btn.cc-deny-all{background:#D2913F!important;border:1px solid #D2913F!important;color:#14110E!important;border-radius:6px!important;font-weight:700!important;text-transform:none!important;letter-spacing:0!important}',
    '.cc-btn.cc-settings{background:transparent!important;border:1px solid #1F1915!important;color:#1F1915!important;border-radius:6px!important;font-weight:500!important;text-transform:none!important;letter-spacing:0!important}',
    '.cc-btn:hover{filter:brightness(1.06)}',
    '.cc-btn:focus-visible{outline:2px solid #1F1915!important;outline-offset:2px}'
  ].join('');

  function habille(hote) {
    var sr = hote && hote.shadowRoot;
    if (!sr || sr.getElementById('kdd-csm')) return;
    var st = document.createElement('style');
    st.id = 'kdd-csm';
    st.textContent = CSS;
    sr.appendChild(st);
  }

  function cherche() {
    var l = document.querySelectorAll('csm-cookie-consent, [id^="csm-"]');
    for (var i = 0; i < l.length; i++) habille(l[i]);
  }

  var attente = false;
  cherche();
  new MutationObserver(function () {
    if (attente) return;
    attente = true;
    requestAnimationFrame(function () { attente = false; cherche(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
